(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-apercu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function zone(el) { return el.closest('[data-pb-apercu]'); }

    function majFeuille(z, i) {
      var feuilles = z.querySelectorAll('[data-pb-feuille]');
      if (!feuilles.length) return;
      var n = feuilles.length;
      var idx = ((i % n) + n) % n;
      feuilles.forEach(function (f, k) { f.hidden = k !== idx; });
      z.querySelectorAll('[data-pb-aller]').forEach(function (p, k) {
        if (k === idx) { p.setAttribute('aria-current', 'true'); } else { p.removeAttribute('aria-current'); }
      });
      var c = z.querySelector('[data-pb-compte]');
      if (c) c.textContent = (idx + 1) + ' / ' + n;
      z.dataset.pbIndex = String(idx);
    }

    document.addEventListener('click', function (e) {
      var onglet = e.target.closest('[data-pb-onglet]');
      if (onglet) {
        var z1 = zone(onglet);
        if (!z1) return;
        var cible = onglet.dataset.pbOnglet;
        z1.querySelectorAll('[data-pb-onglet]').forEach(function (o) {
          o.setAttribute('aria-selected', String(o.dataset.pbOnglet === cible));
        });
        z1.querySelectorAll('[data-pb-panneau]').forEach(function (p) {
          p.hidden = p.dataset.pbPanneau !== cible;
        });
        return;
      }

      var fleche = e.target.closest('[data-pb-page]');
      if (fleche) {
        var z2 = zone(fleche);
        if (!z2) return;
        var cur = parseInt(z2.dataset.pbIndex || '0', 10);
        majFeuille(z2, fleche.dataset.pbPage === 'suiv' ? cur + 1 : cur - 1);
        return;
      }

      var past = e.target.closest('[data-pb-aller]');
      if (past) {
        var z3 = zone(past);
        if (z3) majFeuille(z3, parseInt(past.dataset.pbAller, 10));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var act = document.activeElement;
      if (!act || !act.closest) return;
      var z = act.closest('[data-pb-apercu]');
      if (!z || !act.closest('[data-pb-page],[data-pb-aller]')) return;
      var cur = parseInt(z.dataset.pbIndex || '0', 10);
      majFeuille(z, e.key === 'ArrowRight' ? cur + 1 : cur - 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-carte"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pb-etape]');
    if (!b) return;
    var zone = b.closest('[data-pb-carte]');
    if (!zone) return;
    var i = b.dataset.pbEtape;
    zone.querySelectorAll('.pb-carte__pin').forEach(function (p) {
      if (p.dataset.pbEtape === i) { p.setAttribute('data-actif', 'true'); } else { p.removeAttribute('data-actif'); }
    });
    zone.querySelectorAll('.pb-carte__item').forEach(function (p) {
      p.setAttribute('aria-pressed', String(p.dataset.pbEtape === i));
    });
    zone.querySelectorAll('[data-pb-fiche]').forEach(function (f) {
      f.hidden = f.dataset.pbFiche !== i;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-galerie"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pb-gal]');
    if (!b) return;
    var zone = b.closest('[data-pb-galerie]');
    var piste = zone && zone.querySelector('[data-pb-piste]');
    if (!piste) return;
    var carte = piste.querySelector('.pb-gal__carte');
    var pas = carte ? carte.getBoundingClientRect().width + 18 : piste.clientWidth * 0.8;
    piste.scrollBy({ left: b.dataset.pbGal === 'suiv' ? pas : -pas, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-itineraires"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pb-itin-bouton]');
    if (!b) return;
    var zone = b.closest('[data-pb-itin]');
    if (!zone) return;
    var i = b.dataset.pbItinBouton;
    zone.querySelectorAll('[data-pb-itin-bouton]').forEach(function (x) {
      x.setAttribute('aria-selected', String(x.dataset.pbItinBouton === i));
    });
    zone.querySelectorAll('[data-pb-itin-panneau]').forEach(function (p) {
      p.hidden = p.dataset.pbItinPanneau !== i;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-produit-achat"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest('[data-pb-couverture-bascule]');
    if (!bouton) return;
    var zone = bouton.closest('.pb-couv-zone');
    var couv = zone && zone.querySelector('.pb-couv');
    if (!couv) return;
    var ouvert = couv.getAttribute('data-ouvert') === 'true';
    couv.setAttribute('data-ouvert', ouvert ? 'false' : 'true');
    bouton.setAttribute('aria-pressed', ouvert ? 'false' : 'true');
    var suivant = ouvert ? bouton.dataset.libelleFerme : bouton.dataset.libelleOuvert;
    if (suivant) bouton.textContent = suivant;
  });

  } catch(e) { console.error(e); }
})();
})();
